import CryptoCloudIcon from '../../assets/images/payment-types/crypto-cloud-icon.webp'
import StripeIcon from '../../assets/images/payment-types/stripe-icon.webp'
import MasterCardIcon from '../../assets/images/payment-types/master-card-icon.webp'
import VisaIcon from '../../assets/images/payment-types/visa-icon.webp'
import UsdtIcon from '../../assets/images/payment-types/usdt-icon.webp'
import CashIcon from '../../assets/images/payment-types/cash-icon.webp'


export const PAYMENT_ICONS = [
    {
        img: CryptoCloudIcon,
        title: 'Crypto Cloud',
    },
    {
        img: StripeIcon,
        title: 'Stripe',
    },
    {
        img: MasterCardIcon,
        title: 'Master Card',
    },
    {
        img: VisaIcon,
        title: 'Visa',
    },
    {
        img: UsdtIcon,
        title: 'USDT',
    },
    {
        img: CashIcon,
        title: 'Cash on Delivery',
    },
]